import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {ButtonAlignment, FormLayout, TextAlignment} from '../../../../../types/createStylesParams'

export type LayoutSettingsParams = {
  showTitle: SettingsParamType.Boolean
  showDescription: SettingsParamType.Boolean
  showFormFieldLabels: SettingsParamType.Boolean
  textAlignment: SettingsParamType.String
  buttonAlignment: SettingsParamType.String
  formLayout: SettingsParamType.String
}

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showDescription: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showFormFieldLabels: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  textAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Center,
  },
  buttonAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => ButtonAlignment.Stretch,
  },
  formLayout: {
    type: SettingsParamType.String,
    getDefaultValue: () => FormLayout.Packed,
  },
})
